<template>
  <v-select class="w-full" 
    v-model="tipoCliente" 
    :options="tiposClientes" 
    label="nombre"
    @input="changeTipoCliente"
    placeholder="Selecciona tipo de cliente"
    :disabled="disabled"
    :reduce="id => id.id" 
  />
</template>

<script>
import vSelect from 'vue-select'
import commonComponentsStore from '@/store/common-components/index.js'

export default {
  components: {
    'v-select': vSelect
  },
  props: {
    tipoClienteSelected: String,
    disabled: Boolean
  },
  data () {
    return {
      tipoCliente: (this.tipoClienteSelected !== null && this.tipoClienteSelected !== undefined) ? JSON.parse(JSON.stringify(this.tipoClienteSelected)) : null,
      tiposClientes: [],
      tiposClientesFiltrado: []
    }
  },
  methods: {
    changeTipoCliente () {
      this.$emit('input', this.tipoCliente)
    }
  },
  created () {
    if (!commonComponentsStore.isRegistered) {
      this.$store.registerModule('commonComponentsStore', commonComponentsStore)
      commonComponentsStore.isRegistered = true
    }
    // mostramos los tipos de cliente unicos para que no se repita en el combo
    this.tiposClientes = this.$store.state.commonComponentsStore.tiposClientes.filter((value, index, self) => self.map(item => item.nombre).indexOf(value.nombre) === index)    
  }
}
</script>

<style>

</style>